import React from "react";
import styled, { keyframes } from "styled-components";
import { SmartContainer } from "../styles/Containers";

import icon from './icon-black-green.png';

export const Load = keyframes`
    0% {
        opacity: 0.7;
        transform: scale3d(1,1,1);
    }
    50% {
        opacity: 0.4;
        transform: scale3d(0.95,0.95,0.95);
    }
    100% {
        opacity: 0.7;
        transform: scale3d(1,1,1);
    }
`;

export const StyledIcon = styled(SmartContainer)`
    img {
        transform-origin:center;
        animation: ${Load} 2000ms ease-out infinite !important;
        max-width: 70px;
    }
`
export const StyledCaptureCollabIcon = () => {
    return (
        <StyledIcon>
            <img alt="Cpature Collab Loading" src={icon} />
        </StyledIcon>
    )
}
